module.exports = __webpack_public_path__ + "static/img/87008D_1_R_20210918_fit.caf7111.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/87008D_1_R_20210918_fit.png
// module id = Dffu
// module chunks = 0